import { isFileBasedMediaType } from '@motionelements/core/src/services/catalog.service.js';
import { isElementVariantDownloadableBySubscription } from '@motionelements/core/src/services/download.service.js';

// eslint-disable-next-line
export const mediaType = (product) => {
  return _.get(product, 'mediaType');
};

export const masterVariant = (product) => {
  const variants = product.variants;
  return variants ? variants.find(({ master }) => master) || variants[0] || null : null;
};

// eslint-disable-next-line
export const masterVariantFormat = (product) => {
  return _.get(masterVariant(product), 'format');
};

export const isFree = (product) => {
  if (masterVariant(product)) {
    return _.get(masterVariant(product), 'free');
  }
  return _.get(product, 'free');
};

// eslint-disable-next-line
export const isFileBasedProduct = (product) => {
  return isFileBasedMediaType(mediaType(product)) && masterVariantFormat(product) !== 'url';
};

export const isDownloadable = (product) => {
  if (masterVariant(product)) {
    return masterVariant(product).downloadable;
  }
  return false;
};

export const downloadMethod = (product, variant, userSubscriptions = []) => {
  switch (true) {
    case isElementVariantDownloadableBySubscription(product, variant, userSubscriptions):
      return 'subscription';
    case isFree(product):
      return 'free';
    case isDownloadable(product):
      return 'redownload';
    default:
      return false;
  }
};

// eslint-disable-next-line
export const albumArtUrl = (product) => {
  return _.get(product, 'albumArt.jpg.url');
};
